import { render, staticRenderFns } from "./Downtime.vue?vue&type=template&id=01ce6f5e&scoped=true&"
import script from "./Downtime.vue?vue&type=script&lang=js&"
export * from "./Downtime.vue?vue&type=script&lang=js&"
import style0 from "./Downtime.vue?vue&type=style&index=0&id=01ce6f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce6f5e",
  null
  
)

export default component.exports